import { render, staticRenderFns } from "./content-book-smart-pin.vue?vue&type=template&id=18b8d68e&scoped=true&"
import script from "./content-book-smart-pin.vue?vue&type=script&lang=js&"
export * from "./content-book-smart-pin.vue?vue&type=script&lang=js&"
import style0 from "./content-book-smart-pin.vue?vue&type=style&index=0&id=18b8d68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b8d68e",
  null
  
)

export default component.exports